export const objectToUrlParams = (obj: Record<string, any>): string => {
  return Object.keys(obj)
    .filter(key => ![undefined, null].includes(obj[key]))
    .map(key => `${ encodeURIComponent(key) }=${ encodeURIComponent(obj[key]) }`)
    .join('&');
};
